@mixin background {
  border-radius: 10px;
}

.heater-settings-row {
  .heater-settings {
    @include background;
    .label {
      white-space: nowrap;
      font-size: 20px;
      font-weight: 100;
      width: 50%;
    }
    .boolean-component {
      float: none !important;
    }

    @media (max-width: 500px) {
      .mobile-steamer-warm{
        padding-top: 0 !important;
      }
      .heater-settings {
        display: flex;
        flex-direction: column;
      }
    }

    @media (min-width: 501px) and(max-width: 1000px){
      .boolean-component {
        float: right !important;
      }
    }
  }

  @media (min-width: 501px) and(max-width: 767px) {
    .heater-settings{
      padding-left: 0 !important;
    }
    .tab-view-none{
      display: none;
    }
    .heater-settings {
      display: flex;
      align-items: center;
      .mobile-steamer-warm {
        display: flex;
      }
      .heater-warm {
        display: flex;
        justify-content: end;
      }
    }
  }
  
  @media (min-width: 768px) and (max-width: 850px) {
    .tab-view {
      width: 50% !important;
    }
    .tab-view-none{
      display: none;
    }
    .heater-settings {
      display: flex;
      align-items: center;
      .mobile-steamer-warm {
        display: flex;
      }
      .heater-warm {
        display: flex;
        justify-content: end;
      }
    }
  }
}

@media (min-width: 1400px) {
  .heater-settings-row {
    .heater-settings {
        .label{
          font-size: 15px;
        }
        .tab-view-none{
          display: none;
        }
      /*.switch {
        .block1 {
          .btn-custom{
            padding: 3px 8px 4px 8px;
            font-size: 13px !important;
          }
        }
        .block2 {
          top: -30px;
          .btn{
            font-size: 13px !important;
          }
          .button-on{
            padding: 4px 10px 4px 10px;
            transform: translate3d(43px, 0px, 0px);
          }
          .button-off{
            padding: 4px 8px 4px 8px;
            transform: translate3d(-1px, 0px, 0px);
          }
        }
      }*/
    }
  }
}


// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-dev-vm-baristadj/src/app/components/recipe/drink-settings/heater-settings/heater-settings.scss